import React, {useState} from 'react';
import styles from './ParticipationOverview.module.css';
import icTakes from "../assets/icon/ic_takes.svg";
import icNav from "../assets/icon/ic_nav.svg";
import icWallets from "../assets/icon/ic_wallets.svg";
import icApk from "../assets/icon/ic_play_store.svg";
import icApp from "../assets/icon/ic_app_store.svg";
import icPS from "../assets/icon/ic_apk_store.svg";
import icImportant from "../assets/icon/ic_important.svg";
import {useTranslation} from "react-i18next";
import icRecommend from "../assets/icon/ic_recommend.svg";
import icVideo from "../assets/icon/ic_video.svg";
import ModalVideo from "react-modal-video";


const ParticipationOverview: React.FC = () => {
    const { t } = useTranslation();
    const [isVideoOpen, setIsVideoOpen] = useState<boolean>(false);

    return (
        <section className={styles.participationOverview}>
            <h2 className={styles.title}>{t('partOverview')}</h2>
            <p className={styles.description}>
                {t('partEnroll')}
            </p>
            <p className={styles.timeEstimate}>
                <img
                    src={icTakes}
                    className={styles.icon}
                />
                {t('takes')}
            </p>
            <div className={styles.stepsContainer}>

                <div className={styles.stepCard}>
                    <div className={styles.stepNumber}>1</div>
                    <p className={styles.stepTitle}>{t('partSetup')}</p>
                    <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px'}}>
                        {/*<img className={styles.icWallets} src={icWallets}/>*/}
                        {/*<span className={styles.stepDetail}>Metamask</span>*/}
                        {/*<img className={styles.icRecommendIcon} src={icRecommend}/>*/}
                        {/*<span className={styles.recommendedText}>{t('recommended')}</span>*/}
                </div>

                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '4px'}} onClick={() => {
                    window.open('https://medium.com/@core_dao/add-core-to-metamask-7b1dd90041ce', '_blank');
                    }}>
                        <p className={styles.stepDescription}>{t('newToWallets')} <span
                            style={{textDecoration: 'underline'}}>{t('clickForGuide')}</span></p>
                        <img
                            src={icNav}
                            className={styles.iconNav}
                        />
                    </div>
                </div>
                <div className={styles.stepCard}>
                    <div className={styles.stepNumber}>2</div>
                    <p className={styles.stepTitle}>{t('partComplete')}</p>

                    <div className={styles.videoGuideLink}
                         onClick={() =>setIsVideoOpen(true)}>
                        <p>{t('videoGuideAllIn')}</p>
                        <img className={styles.icVideo} src={icVideo}/>
                    </div>
                    <ModalVideo
                        channel="custom"
                        isOpen={isVideoOpen}
                        url='https://satoshiapp.xyz/hubfs/Pell/Mobile_Quests.mp4'
                        onClose={() => setIsVideoOpen(false)}
                    />

                </div>
                <div className={styles.stepCard}>
                    <div className={styles.stepNumber}>3</div>
                    <p className={styles.stepTitle}>{t('downloadAndReg')}</p>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer'
                    }}>
                        <img src={icPS} onClick={() => {
                            window.open('https://play.google.com/store/apps/details?id=com.sat21.global.pro', '_blank');
                        }}/>
                        <img src={icApk} onClick={() => {
                            window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                        }}/>
                        <img src={icApp} style={{height: 25, width: 81}} onClick={() => {
                            window.open('https://apps.apple.com/app/satoshi-app-get-airdrops/id6736825074', '_blank');
                        }}/>
                    </div>
                </div>
                <div className={styles.stepCard}>
                    <div className={styles.stepNumber}>4</div>
                    <p className={styles.stepTitle}>
                        {t('partEnter')}</p>
                </div>
                <div className={styles.stepCard}>
                    <div className={styles.stepNumber}>5</div>
                    <p className={styles.stepTitle}>{t('sitTight')}</p>
                </div>
                <div className={styles.stepCard}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <img className={styles.icImportant} src={icImportant}/>
                        <span className={styles.icImportantText}>{t('important')}</span>
                    </div>
                    <p className={styles.stepNote}>{t('tuned')}</p>
                </div>

            </div>
        </section>
    );
};

export default ParticipationOverview;